import { Github, ExternalLink } from "lucide-react"

export interface Project {
  name: string
  description: string
  link: string
  repo?: string
  languages: string[]
}

interface ProjectsListProps {
  projects: Project[]
}

export default function ProjectsList({ projects }: ProjectsListProps) {
  return (
    <div className="space-y-8 mb-16">
      {projects.map((project, index) => (
        <div
          key={index}
          className="bg-background border border-turquoise/10 rounded-xl p-6 transition-all duration-300 hover:shadow-md hover:shadow-turquoise/5 relative overflow-hidden"
        >
          <div className="absolute inset-0 opacity-30 pointer-events-none">
            <div className="absolute inset-[1px] rounded-xl [background:linear-gradient(45deg,#0a0a0a,theme(colors.background)_50%,#0a0a0a)_padding-box,conic-gradient(from_var(--border-angle),theme(colors.contentBorder)_80%,_theme(colors.turquoise.DEFAULT)_86%,_theme(colors.turquoise.light)_90%,_theme(colors.turquoise.DEFAULT)_94%,_theme(colors.contentBorder))_border-box] border border-transparent animate-border"></div>
          </div>
          <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
            <div className="space-y-3 flex-1">
              <div className="flex items-center gap-2">
                <h3 className="text-xl font-bold text-text">{project.name}</h3>
                <div className="flex gap-2">
                  {project.repo && (
                    <a
                      href={project.repo}
                      target="_blank"
                      rel="noreferrer"
                      className="text-gray-400 hover:text-turquoise transition-colors"
                      aria-label={`GitHub repository for ${project.name}`}
                    >
                      <Github size={18} />
                    </a>
                  )}
                  <a
                    href={project.link}
                    target="_blank"
                    rel="noreferrer"
                    className="text-gray-400 hover:text-turquoise transition-colors"
                    aria-label={`Live demo for ${project.name}`}
                  >
                    <ExternalLink size={18} />
                  </a>
                </div>
              </div>
              <p className="text-gray-300">{project.description}</p>
            </div>

            <div className="flex flex-wrap gap-2 md:justify-end md:min-w-[180px]">
              {project.languages.map((lang, i) => (
                <span key={i} className="px-2.5 py-0.5 text-xs rounded-full bg-turquoise/10 text-turquoise-light">
                  {lang}
                </span>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

